import { render, staticRenderFns } from "./df-form-manager.vue?vue&type=template&id=597eb00d&"
import script from "./df-form-manager.ts?vue&type=script&lang=js&"
export * from "./df-form-manager.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports